import { FC, MouseEvent } from "react";
import CardBody from "./card-body";
import CardImage from "./card-image";
import Link from "next/link";
import { PRODUCT_SLUG, HOME_EXPERIMENT_LOCATIONS } from "@types";
import useHomeExperiments from "@shared/hooks/useHomeExperiments";
import { useCardAction } from "./useCartAction";
import { ICard } from "./types";

const GridCard: FC<
  ICard & {
    href: string;
    isFestival?: boolean;
    hugElement?: boolean;
    showCardFooter?: boolean;
  }
> = (props) => {
  const { notFullyClickable } = props;

  const homeExperimentSubmitter = useHomeExperiments();
  const { openCouponModal } = useCardAction();

  const openCouponModalHandler = () => {
    openCouponModal({
      id: props.id,
      price: props.price as number,
      sku: props.sku,
      title: props.title,
      expire: props.details_expire,
      slug: props.slug,
      type: props.type,
    });
  };

  const discount = props?.festival?.discount_value;
  const hasToShowDiscountIconInImage = Boolean(
    props.showShoppingCart && discount && discount > 0
  );

  const linkClickHandler = (e: MouseEvent<HTMLAnchorElement>) => {
    if (props.details_expire?.can_purchase) {
      e.preventDefault();
      e.stopPropagation();
      openCouponModalHandler();
    }
  };

  const CardImageComponent = (
    <CardImage
      details_expire={props.details_expire}
      svg_image={props.svg_image}
      png_image={props.png_image}
      webp_image={props.webp_image}
      svg_featured_image={props.svg_featured_image}
      png_featured_image={props.png_featured_image}
      webp_featured_image={props.webp_featured_image}
      type={props.type}
      slug={props.slug}
      sku={props.sku}
      variant={props.variant}
      isFavorite={props.isFavorite}
      id={props.id}
      width={props.imageWidth}
      title={props.title}
      showDiscountIcon={hasToShowDiscountIconInImage}
      festival={props.festival}
      showFolderIcon={props.showFolderIcon}
      folderStatus={props.folderStatus}
      handleFolderAction={props.handleFolderAction}
      changeFavorite={props.changeFavorite}
      showSubscriptionBadge={props.showSubscriptionBadge}
      renderSubscriptionFooter={props.renderSubscriptionFooter}
    />
  );

  const CardContent = (
    <>
      {CardImageComponent}
      <CardBody {...props} details_expire={undefined} />
    </>
  );

  return (
    <div
      className="rounded-8 border bg-fds-primary border-fds-cart hover:shadow-brand-md flex flex-col p-2  md:p-3"
      onClick={() => {
        homeExperimentSubmitter({
          location: HOME_EXPERIMENT_LOCATIONS.CARD,
          name: props.sliderSlug as PRODUCT_SLUG,
        });
      }}
    >
      {notFullyClickable ? (
        CardContent
      ) : (
        <Link
          href={props.href}
          prefetch={false}
          target={props.linkTarget || "_self"}
          onClick={linkClickHandler}
          draggable={false}
        >
          {CardContent}
        </Link>
      )}
    </div>
  );
};
export default GridCard;
